import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-layout-embedded',
  templateUrl: './layout-embedded.component.html',
  styleUrls: ['./layout-embedded.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
})
export class LayoutEmbeddedComponent {}
